import React, { useState } from "react";
import './style.scss'
import {
  CabinetCasesIconSite,
  CabinetClientsIconCompare,
  CabinetClientsIconPresentation,
  CabinetClientsIconSF,
  CabinetClientsIconSite, CabinetCompanyIconAnalytics, CabinetCompanyIconSettings,
  CabinetCrmIconCalendar,
  CabinetCrmIconDeals,
  CabinetCrmIconFixation,
  CabinetCrmIconRecord,
  CabinetFavoritesIconComplexes,
  CabinetFavoritesIconCottageSettment,
  CabinetFavoritesIconObjects, CabinetFinanceIconCard, CabinetFinanceIconLock, CabinetFinanceIconWallet,
  CabinetMenuIconClient,
  CabinetMenuIconCrm,
  CabinetMenuIconCustomers,
  CabinetMenuIconFavorites,
  CabinetMenuIconMoney,
  CabinetMenuIconObjects,
  CabinetMenuIconSecondClient,
  CabinetMenuIconWallet,
  CabinetMortgageIconDocument,
  CabinetMortgageIconPercent,
  CabinetObjectsIconFeed,
  CabinetObjectsIconHouse,
  MenuNavArrowIcon,
  MenuNavPeoplesIcon
} from "../../components/Public/markup/icons";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useCompanyRole from "../../hooks/useCompanyRole";

const PersonalCabinet = () => {

  const [activeMenu, setActiveMenu] = useState(null);

  const location = useLocation();


  const isMenuActive = (content) => {
    const matchPath = (to) =>
      to && (location.pathname === to || location.pathname.startsWith(to + '/'));

    if (Array.isArray(content.to)) {
      if (content.to.some(matchPath)) return true;
    } else if (matchPath(content.to)) {
      return true;
    }

    if (Array.isArray(content.items)) {
      return content.items.some(item => {
        if (Array.isArray(item.to)) {
          return item.to.some(matchPath);
        } else {
          return matchPath(item.to);
        }
      });
    }

    return false;
  };

  const hideCompany = useCompanyRole(["extended_access", "limited_access"]);

  const isFullAccessDepartment = useCompanyRole(["full_access_departament"]);

  const menu = {
    crm: {
      title: 'CRM',
      icon: <CabinetMenuIconCrm />,
      items: [
        {
          to: ["/personalcabinet/clients"],
          title: "Клиенты",
          icon: <MenuNavPeoplesIcon />
        },
        {
          to: ["/personalcabinet/fixations"],
          title: "Фиксации",
          icon: <CabinetCrmIconFixation />
        },
        {
          to: ["/crm/viewing"],
          title: "Записи на просмотр",
          icon: <CabinetCrmIconRecord />
        },
        {
          to: ["/personalcabinet/deals"],
          title: "Сделки",
          icon: <CabinetCrmIconDeals />
        },
        // {
        //   to: "",
        //   title: "Календарь",
        //   icon: <CabinetCrmIconCalendar />
        // },
      ]
    },
    clients: {
      title: 'Клиентам',
      icon: <CabinetMenuIconClient />,
      items: [
        {
          to: ["/crm/presentations"],
          title: "Презентации",
          icon: <CabinetClientsIconPresentation />
        },
        {
          to: ["/crm/filters"],
          title: "Сохраненные фильтры",
          icon: <CabinetClientsIconSF />
        },
        {
          to: ["/crm/compilations"],
          title: "Подборки и сравнение",
          icon: <CabinetClientsIconCompare />
        },
        {
          to: ["/constructor-admin"],
          title: "Личный сайт",
          icon: <CabinetClientsIconSite />
        },
        {
          to: ["/cases"],
          title: "Кейсы",
          icon: <CabinetCasesIconSite />
        },
      ]
    },
    favorites: {
      title: 'Избранное',
      icon: <CabinetMenuIconFavorites />,
      to: "/favorites",
      items: [
        //   {
        //     to: "",
        //     title: "Объекты",
        //     icon: <CabinetFavoritesIconObjects />
        //   },
        //   {
        //     to: "",
        //     title: "Комплексы",
        //     icon: <CabinetFavoritesIconComplexes />
        //   },
        //   {
        //     to: "",
        //     title: "Поселки",
        //     icon: <CabinetFavoritesIconCottageSettment />
        //   },
      ]
    },
    objects: {
      title: 'Объекты',
      icon: <CabinetMenuIconObjects />,
      items: [
        // {
        //   to: "/secondary",
        //   title: "Вторичка",
        //   icon: <CabinetFavoritesIconComplexes />
        // },
        {
          to: ["/personal/objects"],
          title: "Мои объекты",
          icon: <CabinetFavoritesIconComplexes />
        },
        // {
        //   to: "/suburbans/spb/",
        //   title: "Загородка",
        //   icon: <CabinetObjectsIconHouse />
        // },
        // {
        //   to: "",
        //   title: "Фиды",
        //   icon: <CabinetObjectsIconFeed />
        // },
      ]
    },
    // mortgage: {
    //   title: 'Ипотека',
    //   icon: <CabinetMenuIconMoney />,
    //   items: [
    //     {
    //       to: "",
    //       title: "Ипотечные заявки",
    //       icon: <CabinetMortgageIconPercent />
    //     },
    //     {
    //       to: "",
    //       title: "Списки документов",
    //       icon: <CabinetMortgageIconDocument />
    //     },
    //   ]
    // },
    ...(hideCompany ? [] : {
      company: {
        title: 'Компания',
        icon: <CabinetMenuIconCustomers />,
        items: [
          {
            to: ["/personalcabinet/structure", "/personalcabinet/requests", "/personalcabinet/employees"],
            title: "Сотрудники",
            icon: <MenuNavPeoplesIcon />
          },
          {
            to: [""],
            title: "Аналитика",
            icon: <CabinetCompanyIconAnalytics />,
            isDisabled: true
          },
          ...(isFullAccessDepartment ? [] : [{
            to: ["/personalcabinet/company"],
            title: "Настройки",
            icon: <CabinetCompanyIconSettings />
          }])
        ]
      }
    }),
    finances: {
      title: 'Финансы',
      icon: <CabinetMenuIconWallet />,
      items: [
        {
          to: ["/payment"],
          title: "Онлайн оплата",
          icon: <CabinetFinanceIconCard />
        },
        // {
        //   to: "",
        //   title: "История операций",
        //   icon: <CabinetFinanceIconWallet />
        // },
        ...(isFullAccessDepartment ? [] : [{
          to: [""],
          title: "Закрытие сделок",
          icon: <CabinetFinanceIconLock />,
          isDisabled: true
        }]),
      ]
    },
    profile: {
      title: 'Профиль',
      icon: <CabinetMenuIconSecondClient />,
      to: "/personalcabinet/profile",
      items: [

      ]
    },
  }

  return (
    <>
      <ul className="cabinet-menu">
        {Object.entries(menu).map(([key, content]) => {
          const isActive = isMenuActive(content);
          const hasItems = Array.isArray(content.items) && content.items.length > 0;

          return (
            <li
              key={key}
              onMouseEnter={() => hasItems && setActiveMenu(key)}
              onMouseLeave={() => hasItems && setActiveMenu(null)}
              className={isActive ? 'active' : ''}
            >
              {content.to && !hasItems ? (
                <Link to={content.to} className="cabinet-menu__link">
                  <span className="cabinet-menu__icon">{content.icon}</span>
                  {content.title}
                </Link>
              ) : (
                <>
                  <span className="cabinet-menu__icon">{content.icon}</span>
                  {content.title}
                  {hasItems && (
                    <BlockMenu content={content} isActive={activeMenu === key} />
                  )}
                </>
              )}
            </li>
          );
        })}
      </ul>


    </>
  )
}

export const BlockMenu = ({ content }) => {
  const location = useLocation();

  return (
    <div className="sidebar menu-nav">
      <p className="sidebar__title">{content.title}</p>
      <nav className="sidebar__list">
        {content.items.map(({ to, title, icon, isDisabled }, index) => {
          const toArray = Array.isArray(to) ? to : [to];
          const validPaths = toArray.filter(p => typeof p === 'string' && p.trim() !== "");

          const isActive = validPaths.some(p =>
            location.pathname === p || location.pathname.startsWith(p + '/')
          );

          const isExternal = validPaths.length === 1 && /^https?:\/\//.test(validPaths[0]);
          const linkPath = validPaths[0] || "#";

          const commonClasses = `menu-nav__item${isActive ? ' active' : ''}${isDisabled ? ' cabinet-menu__disabled-item' : ''}`;

          const itemContent = (
            <>
              <div className="menu-nav__item-text">
                {icon}
                {title}
              </div>
              <div className="menu-nav__item-arrow">
                <MenuNavArrowIcon />
              </div>
              {isDisabled && (
                <div className="tooltip">В разработке</div>
              )}
            </>
          );

          if (isDisabled) {
            return (
              <a className={commonClasses} key={index}>
                {itemContent}
              </a>
            );
          }

          return isExternal ? (
            <a
              href={linkPath}
              className={commonClasses}
              key={index}
              target="_blank"
              rel="noopener noreferrer"
            >
              {itemContent}
            </a>
          ) : (
            <Link
              to={linkPath}
              className={commonClasses}
              key={index}
            >
              {itemContent}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default PersonalCabinet
